import { TutorPackage, BookingCurrency, TutorLevel, BookingLanguage } from './booking'

export enum PRODUCT_CATEGORY {
  PRIVATE_TUTORING = 'tutoring',
  VIDEO_CHAT = 'videoChat',
}

export type GetProductRequest = { language: BookingLanguage } | undefined

export interface ProductAPI {
  priceUsd: string
  id: number
  type: TutorPackage
  hours: number
  minutes: number
  category: PRODUCT_CATEGORY
  mentorLevel: TutorLevel
  currency: BookingCurrency
  price: number
  priceHourly: number
  travelExpense: number
  travelExpenseHourly: number
  priceHourlyWithTravelExpense: number
  priceTotalWithTravelExpense: number
}

export interface Product {
  priceUsd: string
  id: number
  type: TutorPackage
  hours: number
  minutes: number
  category: PRODUCT_CATEGORY
  tutorLevel: TutorLevel
  currency: BookingCurrency
  price: number
  priceHourly: number
  travelExpense: number
  travelExpenseHourly: number
  priceHourlyWithTravelExpense: number
  priceTotalWithTravelExpense: number
  isCampaign?: boolean
}

export interface BookingProducts {
  tutoringProducts: Product[]
  videoChatProduct: Product
  lowestHourlyPriceProduct?: Product
}

export interface CampaignProducts {
  active: boolean
  category: PRODUCT_CATEGORY
  createdAt: string
  currency: BookingCurrency
  hours: number
  id: number
  mentorLevel: TutorLevel
  minutes: number
  price: number
  priceHourly: number
  priceNok: number
  priceUsd: number
  travelExpense: number
  travelExpenseHourly: number
  type: string
  updatedAt: string
}
